import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateMyDiscovery } from '@/actions/my-discovery/updateMyDiscovery';
import { DiscoveryStatus } from '@/types/discovery.status.type';
import { ApiResponse } from '@/types/response.type';

export interface UseUpdateMyDiscoveryReturn {
  mutate: (
    payload: DiscoveryStatus
  ) => Promise<ApiResponse<DiscoveryStatus> | undefined>;
  result: ApiResponse<DiscoveryStatus> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useUpdateMyDiscovery = (): UseUpdateMyDiscoveryReturn => {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    ApiResponse<DiscoveryStatus> | undefined,
    Error,
    DiscoveryStatus
  >({
    mutationFn: updateMyDiscovery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['my-discovery'] });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
